import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, getToken, clearToken } from "@/lib/api";

export const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState("loading"); // loading | ok | fail

  useEffect(() => {
    let mounted = true;
    if (!getToken()) {
      setState("fail");
      return;
    }
    api
      .get("/admin/me")
      .then(() => mounted && setState("ok"))
      .catch(() => {
        clearToken();
        if (mounted) setState("fail");
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (state === "loading")
    return (
      <div
        data-testid="admin-loading"
        className="min-h-[60vh] flex items-center justify-center font-mono text-xs uppercase tracking-widest-plus text-[#94A3B8]"
      >
        Verifying session…
      </div>
    );
  if (state === "fail") return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
